export default __webpack_public_path__ + "static/media/higher_frame_hi_ident.4b6da2d1.svg";